import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TalentProfileDto } from '../../types/agency';

export interface TalentFormState {
  // Page 1 Data
  basicInfo: Partial<TalentProfileDto> | null;
  associateId: number | null;
  // Page 2 Data
  professionalExp: {
    selectedSphere: string;
    frameworkIds: string[];
    languageIds: string[];
  } | null;
  // Page 3 Data: Intro Video State
  introVideo: {
    url?: string;
    file?: any;
  } | null;
}

const initialState: TalentFormState = {
  basicInfo: null,
  professionalExp: null,
  introVideo: null, // Initial state
  associateId: null,
};

const talentFormSlice = createSlice({
  name: 'talentForm',
  initialState,
  reducers: {
    setAssociateId: (state, action: PayloadAction<number | null>) => {
      state.associateId = action.payload;
    },
    saveBasicInfo: (
      state,
      action: PayloadAction<Partial<TalentProfileDto>>,
    ) => {
      state.basicInfo = action.payload;
    },
    saveProfessionalExp: (
      state,
      action: PayloadAction<TalentFormState['professionalExp']>,
    ) => {
      state.professionalExp = action.payload;
    },
    // ✅ NEW: Action to save intro video state
    saveIntroVideo: (
      state,
      action: PayloadAction<TalentFormState['introVideo']>,
    ) => {
      state.introVideo = action.payload;
    },
    resetTalentForm: (state) => {
      state.associateId = null;
      state.basicInfo = null;
      state.professionalExp = null;
      state.introVideo = null; // Reset here too
    },
  },
});

export const {
  saveBasicInfo,
  saveProfessionalExp,
  saveIntroVideo, // Export this
  resetTalentForm,
  setAssociateId,
} = talentFormSlice.actions;

export default talentFormSlice.reducer;
